import { performPostRequest } from "./NetworkService";
import {mapIntentToRequest} from "./RequestMapper"
import { getApiUrl } from "./UrlMapper";

class NetworkRequestHandler {
    
    async handleRequest(intent, payload, context) {        
        const request = mapIntentToRequest(intent, payload, context);
        const result = await performPostRequest(
            await getApiUrl()[intent],
            JSON.stringify(request)
        );
        if (result instanceof Error) {
            return result;
        } else {
            const resultJson = await result.json()
            return resultJson
        }
    }

}

export default NetworkRequestHandler